import { render } from "./ListDetails.vue?vue&type=template&id=795230ae&scoped=true"
import script from "./ListDetails.vue?vue&type=script&lang=js"
export * from "./ListDetails.vue?vue&type=script&lang=js"

import "./ListDetails.vue?vue&type=style&index=0&id=795230ae&scoped=true&lang=css"

import exportComponent from "D:\\vue\\chk-sop-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795230ae"]])

export default __exports__